const getDefaultState = () => {
  return {
    stagioneTesseratiEsports: null,
    nomeTesseratiEsports: null,
    cognomeTesseratiEsports: null,
    numeroAlboTesseratiEsports: null,
    codTesseraTesseratiEsports: null,
    dataEmissioneDaTesseratiEsports: null,
    dataEmissioneATesseratiEsports: null,
    rowsToSkipTesseratiEsports: 0,
    fetchRowsTesseratiEsports: 25,
    currentPageTesseratiEsports: 1,
    sortColumnTesseratiEsports: "tesserato",
    sortOrderTesseratiEsports: "asc",
  };
};
const state = getDefaultState();

const getters = {
  stagioneTesseratiEsports: (state) => state.stagioneTesseratiEsports,
  nomeTesseratiEsports: (state) => state.nomeTesseratiEsports,
  cognomeTesseratiEsports: (state) => state.cognomeTesseratiEsports,
  idPersonaTesseratiEsports: (state) => state.idPersonaTesseratiEsports,
  numeroAlboTesseratiEsports: (state) => state.numeroAlboTesseratiEsports,
  codTesseraTesseratiEsports: (state) => state.codTesseraTesseratiEsports,
  dataEmissioneDaTesseratiEsports: (state) =>
    state.dataEmissioneDaTesseratiEsports,
  dataEmissioneATesseratiEsports: (state) =>
    state.dataEmissioneATesseratiEsports,
  rowsToSkipTesseratiEsports: (state) => state.rowsToSkipTesseratiEsports,
  fetchRowsTesseratiEsports: (state) => state.fetchRowsTesseratiEsports,
  currentPageTesseratiEsports: (state) => state.currentPageTesseratiEsports,
  sortColumnTesseratiEsports: (state) => state.sortColumnTesseratiEsports,
  sortOrderTesseratiEsports: (state) => state.sortOrderTesseratiEsports,
};

// const actions = {};
const mutations = {
  setNomeTesseratiEsports: (state, value) => {
    state.nomeTesseratiEsports = value;
  },
  setCognomeTesseratiEsports: (state, value) => {
    state.cognomeTesseratiEsports = value;
  },
  setIdPersonaTesseratiEsports: (state, value) => {
    state.idPersonaTesseratiEsports = value;
  },
  setNumeroAlboTesseratiEsports: (state, value) => {
    state.numeroAlboTesseratiEsports = value;
  },
  setFineTesseramento: (state, value) => {
    state.fineTesseramentoTesseratiEsports = value;
  },
  setCodTesseraTesseratiEsports: (state, value) => {
    state.codTesseraTesseratiEsports = value;
  },
  setDataEmissioneDaTesseratiEsports: (state, value) => {
    state.dataEmissioneDaTesseratiEsports = value;
  },
  setDataEmissioneATesseratiEsports: (state, value) => {
    state.dataEmissioneATesseratiEsports = value;
  },
  setFetchRowsTesseratiEsports: (state, value) => {
    state.currentPageTesseratiEsports = 1;
    state.rowsToSkipTesseratiEsports = 0;
    state.fetchRowsTesseratiEsports = value;
  },
  setCurrentPageTesseratiEsports: (state, value) => {
    state.currentPageTesseratiEsports = value;
    state.rowsToSkipTesseratiEsports = parseInt(
      (state.currentPageTesseratiEsports - 1) * state.fetchRowsTesseratiEsports
    );
  },
  setSortColumnTesseratiEsports: (state, value) => {
    state.sortColumnTesseratiEsports = value;
  },
  setSortOrderTesseratiEsports: (state, value) => {
    state.sortOrderTesseratiEsports = value;
  },
  setCategoriaTessera: (state, value) => {
    state.id_categoriaTesseratiEsports = value;
  },
  resetFiltersTesseratiEsports: (state) => {
    Object.assign(state, getDefaultState());
  },
  setRowsToSkipTesseratiEsports: (state) => {
    state.currentPageTesseratiEsports = 1;
    state.rowsToSkipTesseratiEsports = 0;
  },
};

export default {
  state,
  getters,
  mutations,
};
